import { gql } from '@apollo/client';

export * from './awaitingLegacyReposCount.query.generated';

export const AWAITING_LEGACY_REPOS_COUNT = gql`
  query awaitingLegacyReposCount {
    legacyRepos(statusFilter: awaiting) {
      count: nodesCount
    }
  }
`;
